/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { KnowledgeBaseShortInfoResponse } from '../models/KnowledgeBaseShortInfoResponse';
import type { KnowledgeBaseStatusResponse } from '../models/KnowledgeBaseStatusResponse';
import type { KnowledgeBaseTable } from '../models/KnowledgeBaseTable';
import type { KnowledgeBaseTablesResponse } from '../models/KnowledgeBaseTablesResponse';
import type { QueryRequest } from '../models/QueryRequest';
import type { QueryResponse } from '../models/QueryResponse';
import type { TableInfoRequest } from '../models/TableInfoRequest';
import type { TableInfoResponse } from '../models/TableInfoResponse';
import type { UpdateTableRequest } from '../models/UpdateTableRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class KnowledgeBaseEndpointsService {
  /**
   * Add Table To Knowledge Base
   * @param requestBody
   * @returns TableInfoResponse Successful Response
   * @throws ApiError
   */
  public static addTableToKnowledgeBaseKnowledgeBaseApiV1KnowledgeBaseAddTablePost(
    requestBody: TableInfoRequest
  ): CancelablePromise<TableInfoResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/knowledge_base/api/v1/knowledge_base/add_table',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Knowledge Base Detail
   * @param knowledgeBaseId
   * @returns KnowledgeBaseTable Successful Response
   * @throws ApiError
   */
  public static getKnowledgeBaseDetailKnowledgeBaseApiV1KnowledgeBaseDetailKnowledgeBaseIdGet(
    knowledgeBaseId: string
  ): CancelablePromise<KnowledgeBaseTable> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/knowledge_base/api/v1/knowledge_base/detail/{knowledge_base_id}',
      path: {
        knowledge_base_id: knowledgeBaseId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete Knowledge Base
   * @param knowledgeBaseId Knowledge Base ID to filter tables for deletion
   * @returns any Successful Response
   * @throws ApiError
   */
  public static deleteKnowledgeBaseKnowledgeBaseApiV1KnowledgeBaseDeleteDelete(
    knowledgeBaseId: string
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/knowledge_base/api/v1/knowledge_base/delete',
      query: {
        knowledge_base_id: knowledgeBaseId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * List All Tables
   * @param page Page number
   * @param limit Number of items per page
   * @param organisationId Optional filter by organisation ID
   * @param name Filter tables by name (case-insensitive)
   * @param includeInactive Include inactive tables in results
   * @returns KnowledgeBaseTablesResponse Successful Response
   * @throws ApiError
   */
  public static listAllTablesKnowledgeBaseApiV1KnowledgeBaseGet(
    page: number = 1,
    limit: number = 20,
    organisationId?: string,
    name?: string | null,
    includeInactive?: boolean
  ): CancelablePromise<KnowledgeBaseTablesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/knowledge_base/api/v1/knowledge_base/',
      query: {
        page: page,
        limit: limit,
        organisation_id: organisationId,
        name: name,
        include_inactive: includeInactive,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Knowledge Base
   * @param knowledgeBaseId
   * @param requestBody
   * @returns KnowledgeBaseStatusResponse Successful Response
   * @throws ApiError
   */
  public static updateKnowledgeBaseKnowledgeBaseApiV1KnowledgeBaseKnowledgeBaseIdUpdatePatch(
    knowledgeBaseId: string,
    requestBody: UpdateTableRequest
  ): CancelablePromise<KnowledgeBaseStatusResponse> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/knowledge_base/api/v1/knowledge_base/{knowledge_base_id}/update',
      path: {
        knowledge_base_id: knowledgeBaseId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Query Documents
   * @param requestBody
   * @returns QueryResponse Successful Response
   * @throws ApiError
   */
  public static queryDocumentsKnowledgeBaseApiV1KnowledgeBaseQueryPost(
    requestBody: QueryRequest
  ): CancelablePromise<QueryResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/knowledge_base/api/v1/knowledge_base/query',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Extend Knowledge By Url
   * @param knowledgeBaseId
   * @param requestBody
   * @returns void Successful Response
   * @throws ApiError
   */
  public static extendKnowledgeByUrlKnowledgeBaseApiV1KnowledgeBaseExtendKnowledgeByUrlKnowledgeBaseIdPost(
    knowledgeBaseId: string,
    requestBody: { url: string; chunk_size: number; chunk_overlap: number }
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/knowledge_base/api/v1/knowledge_base/extend-knowledge-by-url/{knowledge_base_id}',
      path: {
        knowledge_base_id: knowledgeBaseId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Knowledge Base Short List
   * @param name Filter knowledge_base by name (case-insensitive)
   * @param active Filter knowledge_base activity in results
   * @param xAiAgentOrganizationContext Organization context for accessing tasks
   * @returns Array<KnowledgeBaseShortInfoResponse> Successful Response
   * @throws ApiError
   */
  public static knowledgeBaseShortListKnowledgeBaseApiV1KnowledgeBaseShortListGet(
    name?: string | null,
    active: boolean = true,
    xAiAgentOrganizationContext?: string
  ): CancelablePromise<Array<KnowledgeBaseShortInfoResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/knowledge_base/api/v1/knowledge_base/short-list',
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      query: {
        name: name,
        active: active,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
